import React from "react";
import { EventPhoto } from "./event-photo";
import "./news.css";

export const InsightsPreview = ({ items = [], onOpenPage }) => {
  const item = items[0];
  if (!item) return null;

  const open = (event) => {
    if (!onOpenPage) return;
    event.preventDefault();
    onOpenPage(`insights/${item.slug}`);
  };

  return (
    <section id="insights" className="insights-preview">
      <div className="container">
        <div className="insights-preview-head">
          <div>
            <span className="agent-kicker">INSIGHTS &amp; ACTIVITIES</span>
            <h2>Where industry dialogue becomes enterprise delivery.</h2>
          </div>
          <a
            href="#/insights"
            className="agent-text-link"
            onClick={(event) => {
              event.preventDefault();
              onOpenPage?.("insights");
            }}
          >
            View all insights <span aria-hidden="true">→</span>
          </a>
        </div>
        <article className="insight-feature">
          <div className="insight-feature-meta">
            <span>{item.type}</span>
            <span>{item.date}</span>
            <span>{item.location}</span>
          </div>
          <div className="insight-feature-copy">
            <h3>{item.title}</h3>
            <p>{item.summary}</p>
            <a href={`#/insights/${item.slug}`} onClick={open}>
              Read the story <span aria-hidden="true">→</span>
            </a>
          </div>
          <ul className="insight-theme-list">
            {item.themes.slice(0, 3).map((theme) => <li key={theme}>{theme}</li>)}
          </ul>
        </article>
      </div>
    </section>
  );
};

export const InsightsPage = ({ items = [], onOpenPage }) => (
  <div className="insights-page news-page">
    <main>
      <section className="news-header">
        <div className="container">
          <span className="news-eyebrow">GOLDLY AI</span>
          <h1>News &amp; Insights</h1>
          <p>
            Events, industry conversations and company updates from our team in Singapore and beyond.
          </p>
        </div>
      </section>
      <section className="news-list" aria-label="Latest articles">
        <div className="container">
          {items.map((item, index) => (
            <article className="news-list-item" key={item.slug}>
              <a
                className="news-cover-link"
                href={`#/insights/${item.slug}`}
                data-scroll-ignore
                aria-label={`Read: ${item.title}`}
                onClick={(event) => {
                  if (!onOpenPage) return;
                  event.preventDefault();
                  onOpenPage(`insights/${item.slug}`);
                }}
              >
                <EventPhoto photo={item.cover} priority={index === 0} showCaption={false} />
              </a>
              <div className="news-list-copy">
                <div className="news-meta">
                  <span>{item.type}</span>
                  <time dateTime={item.dateTime}>{item.date}</time>
                </div>
                <h2><a href={`#/insights/${item.slug}`} data-scroll-ignore>{item.title}</a></h2>
                <p>{item.summary}</p>
                <ul className="news-topics" aria-label="Topics">
                  {item.themes.slice(0, 3).map(theme => <li key={theme}>{theme}</li>)}
                </ul>
              <a
                className="news-read-link"
                href={`#/insights/${item.slug}`}
                data-scroll-ignore
                onClick={(event) => {
                  if (!onOpenPage) return;
                  event.preventDefault();
                  onOpenPage(`insights/${item.slug}`);
                }}
              >
                Read article <span aria-hidden="true">→</span>
              </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  </div>
);
